import { Chart } from './chart';

export interface PieData {
    series: number[];
    labels: string[];
}

export const isPieData = (value: unknown): value is PieData => {
    if (value == null || typeof value !== 'object') {
        return false;
    }

    const candidate = value as Partial<PieData>;
    if (!Array.isArray(candidate.labels) || !Array.isArray(candidate.series)) {
        return false;
    }

    return candidate.series.every((item) => typeof item === 'number');
};

export const pieDataToChart = (pie: PieData): Chart => ({
    series: pie.labels.map((label, index) => ({
        name: label,
        data: [{ label, value: pie.series[index] ?? 0 }]
    }))
});
